import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTable, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { OficiosService } from 'src/app/core/apis/orchestrador/api/oficios.service';
import { SolicitacaoService } from 'src/app/core/apis/orchestrador/api/solicitacao.service';
import { Globals } from 'src/app/core/helpers/globals';
import { OrdemHistorico } from 'src/app/core/apis/orchestrador/model/solicitacao/ordem-solicitacao';
import { Titular } from 'src/app/core/apis/orchestrador/model/solicitacao/titular';
import { Foro } from 'src/app/core/apis/orchestrador/model/foro';
import { Vara } from 'src/app/core/apis/orchestrador/model/vara';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { NroProcessoInputComponent } from 'src/app/shared/components/nro-processo-input/nro-processo-input.component';
import { NoSpecialCharsDirective } from 'src/app/shared/directive/no-special-chars.directive';
import { CpfCnpjService } from 'src/app/core/service/cpf-cnpj.service';
import { StringUtil } from 'src/app/shared/util/string-util';
import { CustomValidators } from 'src/app/shared/validators/custom-validators';

@Component({
  selector: 'app-consulta-historico',
  templateUrl: './consulta-historico.component.html',
  styleUrls: ['./consulta-historico.component.css'],
  standalone: true,
    providers: [provideNgxMask()],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        NgxMaskDirective,
        MatTableModule,
        MatMenuModule,
        MatIconModule,
        MatSelectModule,
        MatOptionModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatOptionModule,
        MatButtonModule,
        MatRadioModule,
        MatCheckboxModule,
        FormsModule,
        NgxMaskPipe,
        NoSpecialCharsDirective,
        NroProcessoInputComponent
    ]
})
export class ConsultaHistoricoComponent implements OnInit {

  usuario: any;

  @Input() tokenIam: string;

  form: UntypedFormGroup;

  @ViewChild(MatTable) table: MatTable<Titular>;
  displayedColumns: string[] = ["nome", "nroDocumento", "action"];

  titulares: Titular[];
  foros: Foro[];
  varas: Vara[];

  showSpinnerForo = false;
  showSpinnerVara = false;
  showSpinnerMagistrado = false;

  constructor(
    private globals: Globals,
    private oficiosService: OficiosService,
    private solicitacaoService: SolicitacaoService,
    private cpfCnpjService: CpfCnpjService,
    private dateAdapter: DateAdapter<any>,
    private router: Router,
    public dialog: MatDialog,
    fb: UntypedFormBuilder
  ) {
    this.form = fb.group({
      nroProcesso: [""],
      nroSla: [120, Validators.required],
      titular: fb.group({
        nome: ["", [Validators.required, CustomValidators.validatorOnlyNumber]],
        nroDocumento: ["", Validators.required],
      }),
      foro: ["", Validators.required],
      vara: ["", Validators.required],
      comarca: [{ value: "", disabled: true }, Validators.required],
      uf: [{ value: "", disabled: true }, Validators.required],
      dtaAnotacao: [{ value: new Date(), disabled: true }, Validators.required],
      vlrAcao: [0.0, [Validators.required, CustomValidators.validatorCurrencyZero]],
      anosHistorico: [5, Validators.required]
    });

    this.titulares = [];
    this.usuario = JSON.parse(sessionStorage.getItem("usuario"));
  }

  ngOnInit() {
    this.dateAdapter.setLocale("pt");
    this.loadForos();
  }

  public addTitular(nome: string, nroDocumento: string) {
    let titular = this.buildTitular(nome, nroDocumento);

    if (this.isDocumentoValido(nroDocumento)) {
      const docExistente = this.titulares.filter(titular => titular.documento == nroDocumento);
      if (docExistente.length > 0) {
        this.globals.showSnackBar("Titular já cadastrado!");
        return;
      }
      this.titulares.push(titular);
      this.nome.reset();
      this.nroDocumento.reset();
      if (this.table != undefined)
        this.table.renderRows();
      if (this.titulares.length === 1) {
        this.showMessageDialog();
      }
    } else
      this.globals.showSnackBar("Número do documento inválido!");
  }

  private showMessageDialog() {
    const data = {
      messages: ['Se houver mais titulares, adicionar nesse momento!'],
      confirmText: 'Entendi',
      showCancel: false
    };

    this.dialog.open(DialogComponent, {
      width: '470px',
      data: data
    });
  }

  public removerTitular(titular) {
    let index = this.titulares.indexOf(titular);
    this.titulares.splice(index, 1);
    this.table.renderRows();
  }

  public handleConsultarHistorico() {
    if (window.confirm("Confirmar consulta de histórico?"))
      this.consultarHistorico();
  }

  public isPessoaFisica(nroDocumento: string) {
    return nroDocumento.length == 11;
  }

  private consultarHistorico() {
    this.globals.addToLoading("cadastrar-ordem");

    const ordem = OrdemHistorico.build(this.nroProcesso.value, this.titulares, this.form.value, this.usuario);
    this.solicitacaoService.saveSolicitacao(ordem, this.tokenIam).subscribe({
      next: (response) => {
        this.globals.subtractFromLoading();
        this.globals.showSnackBar("Consulta de histórico enviada com sucesso!", ["snackbar-success"]);
        this.router.navigate(["/ordem"]);
      },
      error: (error) => {
        this.globals.subtractFromLoading();
        if (error.error.Erros)
          error.error.Erros.forEach(erro => this.globals.showSnackBar(erro.message));
        else if (error.error[0].code == 412)
          this.showOrdemDuplicadaDialog();
        else
          this.globals.showSnackBar("Consulta de histórico indisponível, por favor, tente novamente mais tarde.");
      }
    });
  }

  private showOrdemDuplicadaDialog() {
    const data = {
      messages: ['Existe outra ordem em atendimento, por favor, aguarde a finalização.'],
      confirmText: 'Entendi',
      showCancel: false
    };

    this.dialog.open(DialogComponent, {
      width: '490px',
      data: data
    });
  }

  public disableAddDevedor(): boolean {
    return !this.nome.valid || !this.nroDocumento.valid;
  }

  public disableForm(): boolean {
    const isForoValid = this.foro.enabled ? this.foro.valid : true;
    const isVaraValid = this.vara.enabled ? this.vara.valid : true;
    return !this.form.get('nroProcesso').valid || this.titulares.length == 0 || !isForoValid || !isVaraValid;
  }

  public onChangeForo(foro: Foro) {
    this.getVaras(foro.idForo);

    this.form.get("foro").setValue(foro);
  }

  public onChangeVara(vara: Vara) {
    this.uf.setValue(vara.uf);
    this.comarca.setValue(vara.nomePraca);
  }

  public cancelar() {
    if (window.confirm("Deseja cancelar a ação?"))
      this.router.navigate(["/ordem"]);
  }

  private loadForos() {
    this.showSpinnerForo = true;
    this.oficiosService.getForos(this.tokenIam).subscribe(
      (data) => {
        this.foros = data.body;
        this.showSpinnerForo = false;
      },
      (error) => {
        let finalMessage = error?.error?.Erros?.[0]?.message;

        switch(true) {
          case (error.status == 400):
            this.globals.showSnackBar(finalMessage || "Requisição inválida, verifique os dados e tente novamente por favor.");
            break;

          case (error.status == 403):
            this.globals.showSnackBar(finalMessage || "Você não possui permissão para executar esta ação.");
            break;

          case (error.status == 404):
            this.globals.showSnackBar(finalMessage || "Registros não encontrados.");
            break;

          case (error.status == 422):
            this.globals.showSnackBar(finalMessage || "Sua requisição contem campos inválidos, por favor verifique e tente novamente.");
            break;

          case (error.status == 429):
            this.globals.showSnackBar(finalMessage || "Listagem de Foros: limite de requisições atingido, por favor aguarde um minuto e tente novamente.");
            break;

          default:
            this.globals.showSnackBar(error?.error?.Erros?.[0]?.message || "Houve um problema ao realizar a listagem de foros, por favor, tente novamente mais tarde.");
            break;
        }
      }
    );
  }

  private isDocumentoValido(documento: string) {
    return this.cpfCnpjService.validateCpfCnpj(documento);
  }

  private getVaras(idForo: number) {
    this.showSpinnerVara = true;
    this.oficiosService.getVaras(idForo, this.tokenIam).subscribe(
        data => {
          this.varas = data.body;
          this.showSpinnerVara = false;
        }, (error) => {
          let finalMessage = error?.error?.Erros?.[0]?.message;

          switch(true) {
            case (error.status == 400):
              this.globals.showSnackBar(finalMessage || "Requisição inválida, verifique os dados e tente novamente por favor.");
              break;

            case (error.status == 403):
              this.globals.showSnackBar(finalMessage || "Você não possui permissão para executar esta ação.");
              break;

            case (error.status == 404):
              this.globals.showSnackBar(finalMessage || "Registros não encontrados.");
              break;

            case (error.status == 422):
              this.globals.showSnackBar(finalMessage || "Sua requisição contem campos inválidos, por favor verifique e tente novamente.");
              break;

            case (error.status == 429):
              this.globals.showSnackBar(finalMessage || "Listagem de varas por foro: limite de requisições atingido, por favor aguarde um minuto e tente novamente.");
              break;

            default:
              this.globals.showSnackBar(error?.error?.Erros?.[0]?.message || "Houve um problema ao realizar a listagem de varas por foro, por favor, tente novamente mais tarde.");
              break;
          }

          // this.globals.showSnackBar(
          //   "Lista de varas indisponível, por favor, tente novamente mais tarde.");
        }
      );
  }

  private buildTitular(nome: string, nroDocumento: string): Titular {
    return {
      nome: nome.trim(),
      documento: StringUtil.removeNonNumber(nroDocumento)
    };
  }

  get nroProcesso() {
    return this.form.get("nroProcesso");
  }

  get nroSla() {
    return this.form.get("nroSla");
  }

  get nome() {
    return this.form.get("titular.nome");
  }

  get nroDocumento() {
    return this.form.get("titular.nroDocumento");
  }

  get foro() {
    return this.form.get("foro");
  }

  get vara() {
    return this.form.get("vara");
  }

  get uf() {
    return this.form.get("uf");
  }

  get comarca() {
    return this.form.get("comarca");
  }

  get dtaAnotacao() {
    return this.form.get("dtaAnotacao");
  }

  get anosHistorico() {
    return this.form.get("anosHistorico");
  }
}
